import type { RootState } from 'features/app/store/store';

export const isRnsConnectionSuccessSelector = ({ app }: RootState) =>
  app.isRnsConnectionSuccess;

export const isInnerLoadingSelector = ({ app }: RootState) =>
  app.isInnerLoading;

export const selectIsAppUnloading = ({ app }: RootState) => app.isUnloading;

export const selectIsRnsConnectionClosed = ({ app }: RootState) =>
  app.isRnsConnectionClosed;

export const selectIsTokenSetOnHeaders = ({ app }: RootState) =>
  app.isTokenSetOnHeaders;
